module.exports = __webpack_public_path__ + "img/hotmart.4a414766.svg";